import { Component } from '@angular/core';
import { POCReportService } from '../../poc-report/poc-report.component.service';
import { SharedService } from 'src/app/common/services/shared.service';
import { DataType } from 'src/app/common/models/enums/common.enum';
import { AlertService } from 'src/app/common/components/alert/alert.service';
import { GlobalContants } from 'src/app/common/constants/global.contants';
import { ActivatedRoute } from '@angular/router';
import { distinctUntilChanged, Subscription } from 'rxjs';
import { ReportTableColumn } from '../../../models/reports.model';

@Component({
  selector: 'app-house-villa-projects',
  templateUrl: './house-villa-projects.component.html',
  styleUrls: ['./house-villa-projects.component.scss']
})
export class HouseVillaProjectsComponent {

  projectsColumns: ReportTableColumn[] = [
    {
      header: 'project_name',
      columnName: 'reports.PROJECTNAME',
      field: 'project_name',
      isSortable: true,
      border: false,
      isContainsHTML: false,
      showOnMap: true,
      isAnchor: true,
    },
    {
      header: 'governate',
      columnName: 'reports.governate',
      field: 'governate',
      isSortable: true,
      border: false,
      isContainsHTML: false
    },
    {
      header: 'total_land_area',
      columnName: 'reports.total_land_area',
      field: 'total_land_area',
      isSortable: true,
      border: false,
      symbol: DataType.squareMeter,
      isContainsHTML: false,
      convertNumber: true
    },
    {
      header: 'avg_land_area',
      columnName: 'reports.avg_land_area',
      field: 'avg_land_area',
      border: false,
      isSortable: true,
      symbol: DataType.squareMeter,
      isContainsHTML: false,
      convertNumber: true
    },
    {
      header: 'total_no_of_villas',
      columnName: 'reports.noofProperties',
      field: 'total_no_of_villas',
      border: false,
      isSortable: true,
      isContainsHTML: false,
      convertNumber: true
    },
    {
      header: 'total_no_of_plots',
      columnName: 'reports.total_no_of_plots',
      field: 'total_no_of_plots',
      border: false,
      isSortable: true,
      isContainsHTML: false,
      convertNumber: true
    }


  ]

  loading!: boolean;
  projectsdata: any = [];
  projectsCount: number = 0;

  payload: any = {
    pageSize: 20,
    pageNumber: 0,
    sort_order: null,
    year: null
  }

  downloadLoading: any = {
    a: false
  };
  userInfo: any;
  placeCode: any;
  CurrencyCode: any;
  routeSub$: Subscription = new Subscription();

  constructor(private pocReportService: POCReportService,
    private sharedService: SharedService,
    private alertService: AlertService,
    private activatedRoute: ActivatedRoute
  ) {

  }

  ngOnInit() {
    this.userInfo = this.sharedService.getStoreValue(GlobalContants.StoreKey.userInfo);
    this.placeCode = this.sharedService.getStoreValue(GlobalContants.StoreKey.placeCode);
    this.CurrencyCode = this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode);

    this.routeSub$ = this.activatedRoute.queryParams.pipe(
      distinctUntilChanged(),
    ).subscribe((params) => {
      this.payload.pageNumber = 0;
      this.gethouseVillaProjects();
    })

  }

  gethouseVillaProjects() {
    this.loading = true;
    this.pocReportService.getProjects(this.payload).subscribe(
      {
        next: (res: any) => {

          if (res.status === 200) {
            this.projectsdata = res.data.data;
            this.projectsCount = res.data.count;
          } else {
            this.projectsdata = [];
            this.projectsCount = 0;
          }
          this.loading = false;
        },
        error: (error: any) => {
          this.projectsdata = [];
          this.projectsCount = 0;
          this.loading = false;
        }
      }
    )
  }

  onPageEvent(e: any) {
    if (e.previousPageIndex !== e.pageIndex) {
      this.payload.pageNumber = (e.pageSize * e.pageIndex);
      this.gethouseVillaProjects();
    }

  }

  sortData(event: any) {
    let sort = {
      column: event.active,
      order: event.direction
    }
    this.payload.pageNumber = 0;
    this.payload.sort_order = JSON.stringify(sort).replace(/[+]/g, '%2B');
    this.gethouseVillaProjects();
  }

  downloadExcel(event: any, type: string, key: any) {
    this.downlaod(type, 'house_and_villa', key);
  }

  downlaod(type: string, module_name: string, key: any) {
    this.downloadLoading[key] = true;
    this.pocReportService.downloadHouseVillaReport(type, this.userInfo?.user_id).subscribe(
      {
        next: (res: any) => {
          this.downloadLoading[key] = false;
          if (res.status === 200) {
            const downloadUrl = `${this.pocReportService.downloadExcelUrl()}?file_name=${res.data}&city_code=${this.placeCode.toLowerCase()}&module_name=${module_name}`;
            this.sharedService.downloadExcelUrl(downloadUrl);
          } else {
            this.alertService.warn(res.message)
          }
        },
        error: (error: any) => {
          this.downloadLoading[key] = false;
        }
      }
    )
  }

  ngOnDestroy(): void {
    this.routeSub$?.unsubscribe();
  }

}
